<script setup>
import { useAuthStore } from '~/stores/auth'

const props = defineProps({
  isHistoire: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n()
const auth = useAuthStore()
const checkoutStore = useCheckoutStore()
const isExpanded = ref(true)

const columns = computed(() => {
  return auth?.settings?.seo_footer?.columns
})

function toggleExpanded() {
  isExpanded.value = !isExpanded.value
}
</script>

<template>
  <div v-if="(columns?.length > 0 && !checkoutStore.isCheckoutPage) || props.isHistoire">
    <hr class="footer-divider">
    <div class="equal-small-2 seo-footer mt-5">
      <button
        class="seo-footer__toggle mb-5"
        @click="toggleExpanded"
      >
        <span class="equal-small-1 seo-footer__title">
          {{ t('seoFooter.title') }}
        </span>
        <span class="seo-footer__icon">
          <IconsMinus v-if="isExpanded" />
          <IconsPlus v-else />
        </span>
      </button>
      <div
        class="seo-footer__content"
        :class="{ 'seo-footer__content--collapsed': !isExpanded }"
      >
        <div class="row">
          <div
            v-for="(column, index) in columns"
            :key="index"
            class="col-1200-3 col-800-4 col-640-6 col-560-12 mb-5"
          >
            <p v-if="column.title" class="equal-small-2--bold">
              <NuxtLink v-if="column.title_url" :to="column.title_url" :target="column.title_new_tab ? '_blank' : '_self'" :external="column.title_is_external">
                {{ column.title }}
              </NuxtLink>
              <span v-else v-text="column.title" />
            </p>
            <p
              v-for="(link, linkIndex) in column.links"
              :key="linkIndex"
            >
              <NuxtLink :to="link.url" :target="link.new_tab ? '_blank' : null" :external="link.is_external">
                {{ link.label }}
              </NuxtLink>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables';
@import 'bootstrap/scss/mixins';

.seo-footer {
  a {
    color: $color-light;
    text-decoration: none;
  }

  &__toggle {
    display: none;
    width: 100%;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    text-align: left;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    @include media-breakpoint-down(640) {
      display: flex;
    }
  }

  &__title {
    margin: 0;
    color: #e6e6e6;
    font-weight: bold;
  }

  &__icon {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    fill: #e6e6e6;

    svg {
      height: 100%;
      width: 100%;
    }
  }

  &__content {
    @include media-breakpoint-down(640) {
      overflow: hidden;
      transition:
        max-height 0.3s ease-out,
        opacity 0.3s ease-out,
        margin-bottom 0.3s ease-out;
      max-height: 2000px;
      opacity: 1;
      margin-bottom: 0;

      &--collapsed {
        max-height: 0;
        opacity: 0;
        margin-bottom: 0;
      }
    }
  }
}
</style>
